import { Badge } from '@pocketlaw/tetris';
export function EndElement(props) {
    const { attachmentsCount } = props;
    if (attachmentsCount === 0) {
        return null;
    }
    return <Badge size="small" appearance="secondary" value={attachmentsCount}/>;
}
